import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnDestroy,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

// Same key the sraffic-control apps use. They all run on email.drift.com, so one close
// hides the banner on every Drift Email page.
export const SUNSET_BANNER_CLOSED_AT_KEY = 'sunsetBannerClosedAt';

export const SUNSET_FAQ_URL = 'https://help.salesloft.com/s/article/Drift-Sunset-FAQ?language=en_US';

// Set on :root while the banner is visible; _shell.scss shrinks the page container by it
export const SUNSET_BANNER_HEIGHT_VAR = '--tf-sunset-banner-height';

const ONE_DAY_MS = 1000 * 60 * 60 * 24;

// Once closed, the banner comes back after one day.
// localStorage can throw (blocked storage, private mode), so a storage error just
// means the banner shows.
export function isSunsetBannerDismissed(): boolean {
  try {
    const closedAt = window.localStorage.getItem(SUNSET_BANNER_CLOSED_AT_KEY);
    if (!closedAt) {
      return false;
    }
    const diff = Math.abs(Date.now() - new Date(closedAt).getTime());
    return Math.floor(diff / ONE_DAY_MS) < 1;
  } catch (e) {
    return false;
  }
}

function saveSunsetBannerClosedAt(): void {
  try {
    window.localStorage.setItem(SUNSET_BANNER_CLOSED_AT_KEY, new Date().toISOString());
  } catch (e) {
    // ignore: the banner just comes back on the next page load
  }
}

@Component({
  selector: 'sunset-banner',
  templateUrl: './sunset-banner.component.html',
  styleUrls: ['./sunset-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SunsetBannerComponent implements AfterViewInit, OnDestroy {

  readonly faqUrl = SUNSET_FAQ_URL;

  // AppComponent removes the banner and resizes the page container when this fires
  @Output() closed = new EventEmitter<void>();

  @ViewChild('banner') banner: ElementRef;

  ngAfterViewInit() {
    this.updateHeight();
  }

  @HostListener('window:resize')
  updateHeight() {
    if (this.banner) {
      document.documentElement.style.setProperty(SUNSET_BANNER_HEIGHT_VAR, `${this.banner.nativeElement.offsetHeight}px`);
    }
  }

  ngOnDestroy() {
    document.documentElement.style.removeProperty(SUNSET_BANNER_HEIGHT_VAR);
  }

  close() {
    saveSunsetBannerClosedAt();
    this.closed.emit();
  }
}



// WEBPACK FOOTER //
// ./client/app/sunset-banner/sunset-banner.component.ts